import React from "react";
import Icon from "../../../components/AppIcon";

const TopPerformersCard = ({ companies }) => {
  const getPerformanceColor = (percentage) => {
    if (percentage >= 90) return "bg-success";
    if (percentage >= 70) return "bg-warning";
    return "bg-error";
  };

  const getPerformanceIcon = (percentage) => {
    if (percentage >= 90) return "Trophy";
    if (percentage >= 70) return "Award";
    return "AlertTriangle";
  };



  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">
            Top Performers
          </h3>
          <p className="text-sm text-muted-foreground">
            Companies by collection rate
          </p>
        </div>
        <Icon name="TrendingUp" size={20} className="text-success" />
      </div>

      <div className="space-y-4">
        {companies.map((company, index) => (
          <div key={company.id} className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-muted text-sm font-medium text-foreground">
              {index + 1}
            </div>

            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1">
                <h4 className="text-sm font-medium text-foreground truncate">
                  {company.name}
                </h4>
                <div className="flex items-center space-x-1">
                  <Icon
                    name={getPerformanceIcon(company.collectionRate)}
                    size={14}
                    className={
                      company.collectionRate >= 90
                        ? "text-success"
                        : company.collectionRate >= 70
                        ? "text-warning"
                        : "text-error"
                    }
                  />
                  <span className="text-sm font-medium text-foreground">
                    {company.collectionRate}%
                  </span>
                </div>
              </div>

              <div className="w-full bg-muted rounded-full h-2">
                <div
                  className={`h-2 rounded-full transition-all duration-300 ${getPerformanceColor(
                    company.collectionRate
                  )}`}
                  style={{ width: `${company.collectionRate}%` }}
                />
              </div>

              <div className="flex items-center justify-between mt-1">
                <span className="text-xs text-muted-foreground">
                  Sales: ₹{company.sales.toLocaleString()}
                </span>
                <span className="text-xs text-muted-foreground">
                  Collections: ₹{company.collections.toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Average Performance</span>
          <span className="font-medium text-foreground">
            {(() => {
              const validRates = companies
                .map((comp) => parseFloat(comp.collectionRate))
                .filter((rate) => !isNaN(rate));

              const total = validRates.reduce((acc, rate) => acc + rate, 0);
              const average =
                validRates.length > 0
                  ? Math.round(total / validRates.length)
                  : 0;

              return `${average}%`;
            })()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TopPerformersCard;
